import React, { useState } from 'react';
export function Footer() {
  const [activePopup, setActivePopup] = useState(null);
  const openPopup = popupType => {
    setActivePopup(popupType);
  };
  const closePopup = () => {
    setActivePopup(null);
  };
  return <footer className="bg-gray-800 text-white py-12" data-id="element-224">
      <div className="container mx-auto px-4" data-id="element-225">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-226">
          <div data-id="element-227">
            <h3 className="text-xl font-bold mb-4" data-id="element-228">RelaxGlow</h3>
            <p className="text-gray-400" data-id="element-229">
              Soluciones naturales para el alivio de migrañas y dolores de
              cabeza.
            </p>
          </div>
          <div data-id="element-230">
            <h4 className="text-lg font-semibold mb-4" data-id="element-231">Enlaces Rápidos</h4>
            <ul className="space-y-2" data-id="element-232">
              <li data-id="element-233">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-234">
                  Inicio
                </a>
              </li>
              <li data-id="element-235">
                <a href="#benefits" className="text-gray-400 hover:text-white transition-colors" data-id="element-236">
                  Beneficios
                </a>
              </li>
              <li data-id="element-237">
                <a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors" data-id="element-238">
                  Cómo Funciona
                </a>
              </li>
              <li data-id="element-239">
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-240">
                  Testimonios
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-241">
            <h4 className="text-lg font-semibold mb-4" data-id="element-242">Contacto y Legal</h4>
            <ul className="space-y-2" data-id="element-243">
              <li data-id="element-244">
                <button onClick={() => openPopup('contact')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-245">
                  Contacto
                </button>
              </li>
              <li data-id="element-246">
                <button onClick={() => openPopup('terms')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-247">
                  Términos y Condiciones
                </button>
              </li>
              <li data-id="element-248">
                <button onClick={() => openPopup('guarantee')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-249">
                  Garantía
                </button>
              </li>
              <li data-id="element-250">
                <button onClick={() => openPopup('shipping')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-251">
                  Políticas de Envío
                </button>
              </li>
            </ul>
            <div className="mt-4 text-gray-400" data-id="element-252">
              <p data-id="element-253">Teléfono: +50376668786</p>
              <p data-id="element-254">Email: contacto@shopysv.com</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400" data-id="element-255">
          <p data-id="element-256">
            © {new Date().getFullYear()} RelaxGlow. Todos los derechos
            reservados.
          </p>
          <div className="mt-4 bg-gray-700 p-4 rounded-lg max-w-3xl mx-auto" data-id="element-257">
            <h4 className="font-semibold mb-2" data-id="element-258">AVISO MÉDICO IMPORTANTE:</h4>
            <p className="text-sm" data-id="element-259">
              Este producto no está destinado a diagnosticar, tratar, curar o
              prevenir ninguna enfermedad. Los resultados pueden variar de
              persona a persona. No reemplaza la atención médica profesional. Si
              experimenta dolores de cabeza severos, migrañas crónicas o
              cualquier condición médica seria, consulte a un profesional de la
              salud calificado antes de usar este producto. Suspenda el uso si
              experimenta cualquier reacción adversa.
            </p>
          </div>
        </div>
      </div>
      {activePopup && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-260">
          <div className="bg-white text-gray-800 p-6 rounded-lg max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-261">
            <div className="flex justify-between items-center mb-4" data-id="element-262">
              <h3 className="text-xl font-bold" data-id="element-263">
                {activePopup === 'contact' && 'Contacto'}
                {activePopup === 'terms' && 'Términos y Condiciones'}
                {activePopup === 'guarantee' && 'Garantía'}
                {activePopup === 'shipping' && 'Políticas de Envío'}
              </h3>
              <button onClick={closePopup} className="text-gray-500 hover:text-gray-700" data-id="element-264">
                ✕
              </button>
            </div>
            {activePopup === 'contact' && <div data-id="element-265">
                <p className="mb-3" data-id="element-266">
                  Estamos aquí para ayudarte con cualquier pregunta o inquietud.
                </p>
                <p className="mb-3" data-id="element-267">
                  <strong data-id="element-268">Teléfono:</strong> +50376668786
                </p>
                <p className="mb-3" data-id="element-269">
                  <strong data-id="element-270">Email:</strong> contacto@shopysv.com
                </p>
                <p data-id="element-271">
                  Horario de atención: Lunes a Viernes de 8:00 AM a 5:00 PM
                  (Hora local)
                </p>
              </div>}
            {activePopup === 'terms' && <div data-id="element-272">
                <p className="mb-3" data-id="element-273">
                  Al utilizar nuestro sitio web y realizar una compra, aceptas
                  los siguientes términos y condiciones:
                </p>
                <p className="mb-3" data-id="element-274">
                  1. Los precios están sujetos a cambios sin previo aviso.
                </p>
                <p className="mb-3" data-id="element-275">
                  2. Nos reservamos el derecho de modificar o descontinuar
                  cualquier producto.
                </p>
                <p className="mb-3" data-id="element-276">
                  3. La información personal se maneja conforme a nuestra
                  política de privacidad.
                </p>
                <p data-id="element-277">
                  4. El uso del producto es responsabilidad del comprador y debe
                  seguir las instrucciones proporcionadas.
                </p>
              </div>}
            {activePopup === 'guarantee' && <div data-id="element-278">
                <p className="mb-3" data-id="element-279">
                  Ofrecemos una garantía de satisfacción de 30 días en todos
                  nuestros productos.
                </p>
                <p className="mb-3" data-id="element-280">
                  Si no estás completamente satisfecho con tu compra, puedes
                  solicitar un reembolso completo dentro de los 30 días
                  posteriores a la recepción del producto.
                </p>
                <p data-id="element-281">
                  El producto debe ser devuelto en su empaque original y en
                  buenas condiciones para ser elegible para un reembolso.
                </p>
              </div>}
            {activePopup === 'shipping' && <div data-id="element-282">
                <p className="mb-3" data-id="element-283">
                  Realizamos envíos a todo el país con los siguientes tiempos
                  estimados:
                </p>
                <p className="mb-3" data-id="element-284">
                  - San Salvador y alrededores: 3 a 24 horas máximo
                </p>
                <p className="mb-3" data-id="element-285">- Resto del país: 24 a 48 horas</p>
                <p className="mb-3 font-semibold text-blue-600" data-id="element-286">
                  Envío GRATIS a todo El Salvador
                </p>
                <p data-id="element-287">
                  Envios sujetos a condiciones climaticas, asuetos y cualquier
                  otro percance vial o politico del pais
                </p>
              </div>}
          </div>
        </div>}
    </footer>;
}